// Color palette + label helpers for notification category tags. Extracted so
// they can be unit-tested independently of the notification page component.

export const CATEGORY_TAG_COLORS = [
    'magenta',
    'red',
    'volcano',
    'orange',
    'gold',
    'lime',
    'green',
    'cyan',
    'blue',
    'geekblue',
    'purple',
];

export const colorForCategory = (category) => {
    if (!category) return 'default';
    let hash = 0;
    for (let i = 0; i < category.length; i += 1) {
        hash = (hash * 31 + category.charCodeAt(i)) >>> 0;
    }
    return CATEGORY_TAG_COLORS[hash % CATEGORY_TAG_COLORS.length];
};

export const formatCategoryLabel = (category) =>
    category
        .split(/[._-]/)
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');
